"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripLocalIdentifierFromFilters = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
exports.stripLocalIdentifierFromFilters = function (filters) {
    return filters.map(function (filter) {
        if (sdk_model_1.isDashboardAttributeFilter(filter)) {
            return { attributeFilter: omit_1.default(filter.attributeFilter, "localIdentifier") };
        }
        return filter;
    });
};
//# sourceMappingURL=stripLocalIdentifierFromFilters.js.map